export interface ModuleAccess {
  name: string;
  displayName: string;
  icon: string;
  description: string;
}

export const MODULE_ACCESS_OPTIONS: ModuleAccess[] = [
  { name: 'Home', displayName: 'Home', icon: 'home', description: 'Home page and overview' },
  { name: 'Dashboard', displayName: 'Dashboard', icon: 'dashboard', description: 'Main overview and statistics' },
  { name: 'Joborders', displayName: 'Job Entry', icon: 'assignment', description: 'Create and manage job orders' },
  { name: 'Production', displayName: 'Production', icon: 'factory', description: 'Production tracking and management' },
  { name: 'Challan', displayName: 'Challan', icon: 'local_shipping', description: 'Delivery challan management' },
  { name: 'Reports', displayName: 'Reports', icon: 'assessment', description: 'Business reports and analytics' },
  { name: 'Company', displayName: 'Company Setup', icon: 'business', description: 'Company configuration and settings' },
  { name: 'Access Control', displayName: 'Access Control', icon: 'admin_panel_settings', description: 'Role-based access management' },
  { name: 'Master', displayName: 'Masters', icon: 'dataset', description: 'Master data management' },
  { name: 'Accounting', displayName: 'Accounting', icon: 'account_balance', description: 'Financial and accounting modules' },
  { name: 'Production Transfer', displayName: 'Production Transfer', icon: 'swap_horiz', description: 'Reassign in-progress production cases between employees' },
];